import { NavLink, ScrollArea, Stack } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  IconLayoutDashboard,
  IconChartLine,
  IconFileText,
  IconPill,
  IconForms,
  IconShieldCheck,
} from '@tabler/icons-react';
import { PORTAL_NAV_ITEMS } from '../../types/portal';

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string; stroke?: number }>> = {
  IconLayoutDashboard,
  IconChartLine,
  IconFileText,
  IconPill,
  IconForms,
  IconShieldCheck,
};

export function PortalSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav aria-label="Portal navigation">
    <ScrollArea p="sm" style={{ height: '100%' }}>
      <div className="px-3 py-4 mb-2">
        <span className="text-[10px] font-mono tracking-[0.25em] uppercase text-cyan-400/70">
          Precision Longevity
        </span>
      </div>

      <Stack gap={4}>
        {PORTAL_NAV_ITEMS.map((item) => {
          const Icon = iconMap[item.icon];
          const isActive = location.pathname === item.path;

          return (
            <NavLink
              key={item.id}
              label={item.title}
              aria-current={isActive ? 'page' : undefined}
              leftSection={Icon ? <Icon size={20} stroke={1.5} /> : undefined}
              active={isActive}
              onClick={() => navigate(item.path)}
              styles={{
                root: {
                  borderRadius: 'var(--radius-md)',
                  color: isActive ? 'var(--color-accent-primary)' : 'var(--color-text-secondary)',
                  backgroundColor: isActive ? 'rgba(0, 214, 245, 0.12)' : 'transparent',
                  borderLeft: isActive ? '3px solid var(--color-accent-primary)' : '3px solid transparent',
                  '&:hover': {
                    backgroundColor: isActive ? 'rgba(0, 214, 245, 0.12)' : 'rgba(255, 255, 255, 0.05)',
                  },
                },
                label: {
                  fontSize: '0.875rem',
                  fontWeight: isActive ? 600 : 400,
                },
              }}
            />
          );
        })}
      </Stack>
    </ScrollArea>
    </nav>
  );
}
